import React from 'react';
import { ApiDisplay, API_TYPES } from '../../../ApiDisplay';
import { HTTPApiRequestDisplay } from './HTTPApiRequestDisplay';
import { JSFunctionDisplay } from './JSFunctionDisplay';
import { RPCApiRequestDisplay } from './RPCApiRequestDisplay';
import { RpcRestTypeSwitch } from './RpcRestTypeSwitch';
import get from 'lodash/get';

export const SyntaxDisplay = ({
  operation,
  onOpenPlaygroundClick,
  artifactId,
  serviceName,
  JSLayoutType,
}) => {
  const hasRest = get(operation, 'extra.hasRest', true);
  const rpcRequestName = get(
    operation,
    'extra.rpcRequestName',
    'RequestObject',
  );
  const rpcResponseName = get(
    operation,
    'extra.rpcResponseName',
    'ResponseObject',
  );

  return JSLayoutType ? (
    !!operation?.ret && <JSFunctionDisplay operation={operation} />
  ) : (
    <ApiDisplay>
      <RpcRestTypeSwitch hasRest={hasRest} />
      <ApiDisplay.REST showOnTypes={[API_TYPES.RPC_REST]} forceHide={!hasRest}>
        <HTTPApiRequestDisplay
          method={operation?.docs?.request}
          url={operation?.docs?.url}
          onOpenPlaygroundClick={onOpenPlaygroundClick}
        />
      </ApiDisplay.REST>
      <ApiDisplay.RPC forceRender={!hasRest}>
        {!!operation?.ret && (
          <RPCApiRequestDisplay
            rpcRequestName={rpcRequestName}
            rpcResponseName={rpcResponseName}
            methodName={operation?.methodName || operation?.name}
            serviceName={serviceName}
            artifactId={artifactId}
          />
        )}
      </ApiDisplay.RPC>
      <ApiDisplay.JS>
        {!!operation?.ret && <JSFunctionDisplay operation={operation} />}
      </ApiDisplay.JS>
    </ApiDisplay>
  );
};
